export default "__VITE_ASSET__COpY5gmw__"